// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const Play: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9 17.1921V6.80762L17.1538 11.9999L9 17.1921ZM10 15.3499L15.2885 11.9999L10 8.64987V15.3499Z"
                fill="currentColor"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

/* Store Custom Code - Start */
export const PlayOffset: IconOffset = {
    vertical: 0,
    horizontal: 0,
};
/* Store Custom Code - End */

export default React.memo(Play);
